import { CommonProps } from '@sgui-plus/components/cascader-panel'
import { buildProps, definePropType } from '@sgui-plus/utils/props'
import { useSizeProp } from '@sgui-plus/hooks/use-size'
import { UPDATE_MODEL_EVENT, CHANGE_EVENT } from '@sgui-plus/utils/constants'
import { isBool } from '@sgui-plus/utils/util'
import type { CascaderNode, CascaderValue, Tag } from '@sgui-plus/components/cascader-panel'

export const cascaderProps = buildProps({
  ...CommonProps,
  placement: {
    type: String,
    default: 'bottom-start',
  },
  size: useSizeProp,
  placeholder: String,
  disabled: Boolean,
  clearable: Boolean,
  filterable: Boolean,
  filterMethod: {
    type: definePropType<(node: CascaderNode, keyword: string) => boolean>(
      Function
    ),
    default: (node: CascaderNode, keyword: string) =>
      node.text.includes(keyword),
  },
  separator: {
    type: String,
    default: ' / ',
  },
  showAllLevels: {
    type: Boolean,
    default: true,
  },
  fixedHeight : {
    type: Boolean,
    default: false,
  },
  collapseTags: Boolean,
  ellipsisTag:Boolean,
  collapseTagsTooltip: {
    type: Boolean,
    default: false,
  },
  tooltipPlacement: {
    type: String,
    default: 'bottom',
  },
  tooltipEffect : {
    type: String,
    default: 'light',
  },
  tooltipOffset : {
    type: Number,
    default: 0,
  },
  tooltipPopperClass : {
    type: String,
  },
  debounce: {
    type: Number,
    default: 300,
  },
  beforeFilter: {
    type: definePropType<(value: string) => boolean | Promise<any>>(Function),
    default: () => true,
  },
  popperClass: {
    type: String,
    default: '',
  },
  transfer: {
    type: Boolean,
    default: true,
  },
  contentFormat: Function,
  readonly: {
    type: Boolean,
    default: false
  },
  tagsSeparator: {
    type: String,
    default: ' , ',
  },
  validateEvent: {
    type: Boolean,
    default: true,
  }
})

export const cascaderEmits = {
  [UPDATE_MODEL_EVENT]: (val: CascaderValue) => !!val || val === null,
  [CHANGE_EVENT]: (val: CascaderValue) => !!val || val === null,
  focus: (evt: FocusEvent) => evt instanceof FocusEvent,
  blur: (evt: FocusEvent) => evt instanceof FocusEvent,
  visibleChange: (val: boolean) => isBool(val),
  expandChange: (val: CascaderValue) => !!val,
  removeTag: (val: CascaderNode['valueByOption']) => !!val,
  multipleTagRest: (val: Tag[]) => !!val
}
